import { useState, useRef, useEffect } from 'react';
import { Button, Portal } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import ChatWindow from '@/features/ai/chat_window/ChatWindow';

export default function LaikaButton() {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [buttonPosition, setButtonPosition] = useState({ top: 0, right: 0 });

    const toggleChat = () => {
        setIsChatOpen(prev => !prev);
    };

    useEffect(() => {
        if (buttonRef.current && isChatOpen) {
            const rect = buttonRef.current.getBoundingClientRect();
            setButtonPosition({
                top: rect.bottom + 8, // 버튼 아래 8px 간격
                right: window.innerWidth - rect.right - 45 // 더 오른쪽으로 100px 이동
            });
        }
    }, [isChatOpen]);

    return (
        <>
            <Button
                ref={buttonRef}
                size="xs"
                variant="filled"
                radius="md"
                onClick={toggleChat}
                leftSection={<IconSparkles size={16} />}
                style={{ 
                    height: '28px',
                    background: isChatOpen 
                        ? 'linear-gradient(115.79deg, #4871EB -14.96%, #009DC6 96.29%)'
                        : 'linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(115.79deg, #4871EB -14.96%, #009DC6 96.29%)',
                    color: 'white',
                    fontWeight: 400,
                    border: 'none',
                    padding: '4px 8px',
                    fontSize: '14px',
                    gap: '4px',
                    transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => {
                    if (!isChatOpen) {
                        e.currentTarget.style.background = 'linear-gradient(115.79deg, #4871EB -14.96%, #009DC6 96.29%)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isChatOpen) {
                        e.currentTarget.style.background = 'linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(115.79deg, #4871EB -14.96%, #009DC6 96.29%)';
                    }
                }}
            >
                Laika
            </Button>

            {/* 채팅 윈도우 - Portal을 사용하여 body에 렌더링 */}
            {isChatOpen && (
                <Portal>
                    <div 
                        style={{
                            position: 'fixed',
                            top: `${buttonPosition.top}px`,
                            right: `${buttonPosition.right}px`,
                            bottom: 'auto',
                            left: 'auto',
                            zIndex: 1000
                        }}
                        className="laika-chat-wrapper"
                    >
                        <style>
                            {`
                                .laika-chat-wrapper > div {
                                    position: relative !important;
                                    top: auto !important;
                                    right: auto !important;
                                    bottom: auto !important;
                                    left: auto !important;
                                }
                            `}
                        </style>
                        <ChatWindow
                            isOpen={isChatOpen}
                            onClose={() => setIsChatOpen(false)}
                        />
                    </div>
                </Portal>
            )}
        </>
    );
}